import { render, staticRenderFns } from "./BatchList.vue?vue&type=template&id=730a5ae9"
import script from "./BatchList.vue?vue&type=script&lang=js"
export * from "./BatchList.vue?vue&type=script&lang=js"
import style0 from "./BatchList.vue?vue&type=style&index=0&id=730a5ae9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports